import * as crosshairJs from './crosshair.js';
import * as previewJs from './preview.js';
import {copyText} from './util.js';

window.addEventListener('load', () => {
	if (document.documentElement.clientWidth < 768) {
		document.querySelector("meta[name=viewport]").setAttribute('content', 'width=device-width, initial-scale=0.75');
	}

	fetch('api/getCrosshairs').then(r => r.json()).then(data => {
		window.allCrosshairs = data;
		addCrosshairs();
	});

	document.documentElement.addEventListener('mouseleave', e => {
		if (e.clientY > 0)
			return;
		history.replaceState({}, '', '?c=' + crosshairJs.convertParsedToCode(document.getElementById('builderCustomize').currentParsed));
	});
	document.addEventListener('keydown', e => {
		if (e.ctrlKey && e.key === 'z' && document.getElementById('builderCustomize').lastCode !== undefined)
			setCrosshair(document.getElementById('builderCustomize').lastCode);
	});

	addCustomizer(document.getElementById('builderCustomize'), document.getElementById('builderRender'));

	var code = '0';
	const urlParams = new URLSearchParams(window.location.search);
	if (urlParams.has('c')) {
		const tmpCode = crosshairJs.validateCrosshair(urlParams.get('c'));
		if (tmpCode)
			code = tmpCode;
	}

	setCrosshair(code);

	const shareButtonsDiv = document.getElementById("shareButtons");
	const shareButton = document.getElementById("toggleShare").addEventListener('click', e => {
		shareButtonsDiv.style.display = shareButtonsDiv.style.display === 'block' ? null : 'block';
	});

	document.getElementById('shareTwitter').addEventListener('click', e => {
		const url = 'https://twitter.com/intent/tweet?url=' + encodeURIComponent(getShareUrl())
					+ '&text=' + encodeURIComponent('I made this Overwatch 2 Crosshair on ow.vcrdb.net!')
					+ '&hashtags=overwatch,vcrdb&via=VCRDBnet';
		window.open(url, '_blank');
	});
	document.getElementById('shareFacebook').addEventListener('click', e => {
		const url = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(getShareUrl());
		window.open(url, '_blank');
	});
	document.getElementById('shareCopy').addEventListener('click', e => copyText(getShareUrl()));
});

function addCrosshairs() {
	const parent = document.querySelector('.crosshair_showcase');
	const crosshairs = window.allCrosshairs;

	for (let i = 0; i < crosshairs.length; i++) {
		const data = crosshairs[i];
		const showcase = document.createElement('DIV');
		showcase.classList.add('showcase');

		const canvas = crosshairJs.generateCrosshair(data.code);
		if (!canvas) {
			continue;
		}
		showcase.appendChild(canvas);

		if (data.heroImage !== null) {
			const img = document.createElement('IMG');
			img.setAttribute('src', data.heroImage);
			showcase.appendChild(img);
		}

		showcase.addEventListener('click', e => {
			setCrosshair(data.code);
			window.scrollTo({ top: 0, behavior: 'smooth' });
		});

		parent.appendChild(showcase);
	}
}

function setCrosshair(code) {
	const container = previewJs.getCrosshairContainer(code);
	if (!container)
		return;

	const images = document.getElementById('builderRender');
	images.innerHTML = '';

	images.appendChild(container);

	applyCrosshairToCustomizer(crosshairJs.parseCrosshair(code), document.getElementById('builderCustomize'));
}

function addCustomizer(customizer, images, tabSelect) {
	customizer.images = images;

	const sliders = customizer.querySelectorAll('.x-hair-slider');

	for (var i = 0; i < sliders.length; i++) {
		const slider = sliders[i];

		if (slider.children.length !== 0 || !slider.hasAttribute('binding'))
			continue;

		const usePercent = slider.hasAttribute('usepercent');

		const binding = slider.getAttribute('binding');
		const bindingMapped = crosshairJs.crosshairMap[binding];
		const baseValue = crosshairJs.getBaseValue(bindingMapped[0]);

		const txtInput = document.createElement('INPUT');
		const sliderInput = document.createElement('INPUT');

		txtInput.setAttribute('type', 'text');
		txtInput.value = baseValue + (usePercent ? '%' : '');
		sliderInput.setAttribute('type', 'range');
		sliderInput.setAttribute('min', bindingMapped[1]);
		sliderInput.setAttribute('max', bindingMapped[2]);
		sliderInput.setAttribute('step', bindingMapped[3] ? 1 : 0.1);
		sliderInput.setAttribute('value', baseValue);

		txtInput.addEventListener('change', e => {
			if (usePercent)
				txtInput.value = txtInput.value.replaceAll('%', '');
			if (isNaN(txtInput.value)) {
				txtInput.value = sliderInput.value;
				return;
			}
			sliderInput.value = txtInput.value;
			txtInput.value = sliderInput.value + (usePercent ? '%' : '');
			onUserUpdate(customizer, bindingMapped, sliderInput.value);
		});
		sliderInput.addEventListener('input', e => {
			txtInput.value = sliderInput.value + (usePercent ? '%' : '');
			onUserUpdate(customizer, bindingMapped, sliderInput.value);
		});

		slider.appendChild(txtInput);
		slider.appendChild(sliderInput);

		slider.updateValue = function(key, value) {
			txtInput.value = value + (usePercent ? '%' : '');
			sliderInput.value = value;
		};
	}

	const dropdowns = customizer.querySelectorAll('.x-hair-drop');

	for (var i = 0; i < dropdowns.length; i++) {
		const dropdown = dropdowns[i];

		if (dropdown.children.length !== 0 || !dropdown.hasAttribute('binding') || !dropdown.hasAttribute('dropdata'))
			continue;

		const binding = dropdown.getAttribute('binding');
		const bindingMapped = crosshairJs.crosshairMap[binding];
		const baseValue = crosshairJs.getBaseValue(bindingMapped[0]);

		const dropdata = crosshairJs[dropdown.getAttribute('dropdata')];

		const select = document.createElement('SELECT');
		select.classList.add('x-hair-drop-content');

		select.addEventListener('change', e => {
			onUserUpdate(customizer, bindingMapped, select.value);
		});

		for (var optId = bindingMapped[1]; optId <= bindingMapped[2]; optId++) {
			const option = document.createElement('OPTION');
			option.value = optId;
			option.innerText = dropdata[optId];
			if (optId === baseValue)
				option.setAttribute('selected', '');
			select.appendChild(option);
		}

		dropdown.appendChild(select);

		dropdown.updateValue = function(key, value) {
			select.value = value;
		};
	}

	const colors = customizer.querySelectorAll('.x-hair-color');

	for (var i = 0; i < colors.length; i++) {
		const color = colors[i];

		if (color.children.length !== 0 || !color.hasAttribute('binding') || !color.hasAttribute('dropdata'))
			continue;

		const binding = color.getAttribute('binding');
		const bindingMapped = crosshairJs.crosshairMap[binding];
		const baseValue = crosshairJs.getBaseValue(bindingMapped[0]);

		const dropdata = crosshairJs[color.getAttribute('dropdata')];

		const btn = document.createElement('BUTTON');
		btn.classList.add('x-hair-color-btn');

		const btnColor = document.createElement('P');
		btnColor.style.backgroundColor = dropdata[baseValue];
		btn.appendChild(btnColor);

		const content = document.createElement('DIV');
		content.classList.add('x-hair-color-content');

		btn.addEventListener('click', e => {
			e.stopPropagation();
			const visible = content.style.display === 'block';
			content.style.display = visible ? null : 'block';
		});

		document.addEventListener('click', e => content.style.display = null);

		for (var optId = bindingMapped[1]; optId <= bindingMapped[2]; optId++) {
			const div = document.createElement('DIV');
			const option = document.createElement('P');
			option.value = optId;
			option.style.backgroundColor = dropdata[optId];
			if (optId === baseValue)
				option.setAttribute('selected', '');
			div.addEventListener('click', e => {
				e.stopPropagation();
				content.style.display = null;
				btnColor.style.backgroundColor = dropdata[option.value];
				onUserUpdate(customizer, bindingMapped, option.value);
			});
			div.appendChild(option);
			content.appendChild(div);
		}

		color.appendChild(btn);
		color.appendChild(content);

		color.updateValue = function(key, value) {
			btnColor.style.backgroundColor = dropdata[value];
		};
	}
}

function normalizeColor(value) {
	if (value.startsWith('#'))
		value = value.substr(1);
	if (value.length === 8)
		value = value.substr(0, 6);
	value = value.toUpperCase();
	if (!value.match(/^[0-9A-F]{6}$/g))
		return 'FFFFFF';
	return value;
}

function applyCrosshairToCustomizer(parsed, customizer) {
	customizer.currentParsed = parsed;

	for (var key in crosshairJs.crosshairMap) {
		const setting = customizer.querySelector('.settings > div > div[binding="' + key + '"]');

		if (!setting || !setting.updateValue)
			continue;

		const value = crosshairJs.getJsonValue(parsed, crosshairJs.crosshairMap[key][0]);

		setting.updateValue(key, value);
	}
}

function onUserUpdate(customizer, bindingMapped, value) {
	if (typeof value === 'string') {
		value = parseFloat(value);
	}
	crosshairJs.setJsonValue(customizer.currentParsed, bindingMapped[0], bindingMapped.length >= 5 ? bindingMapped[4](value) : value);

	rerenderImages(customizer);
}

function getCurrentValue(customizer, mapping) {
	return crosshairJs.getJsonValue(customizer.currentParsed, mapping[0]);
}

function rerenderImages(customizer) {
	if (!customizer.images)
		return;

	const children = customizer.images.children;
	for (var i = 0; i < children.length; i++) {
		const canvas = children[i].querySelector('x-hair > canvas');
		crosshairJs.renderCrosshair(customizer.currentParsed, canvas, false, customizer.currentTab);
	}
}

function getShareUrl() {
	return document.location.origin + document.location.pathname + '?c=' + crosshairJs.convertParsedToCode(document.getElementById('builderCustomize').currentParsed);
}
